// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3x62R","title":"Header_title__3o7W9","side":"Header_side__2BKyk"};